// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.contact-div-main {
  display: flex;
  gap: 2rem;
}

.dark-mode a {
  color: #ffffff;
}

.contact-div-main > * {
  flex: 1 1;
}

.contact-title {
  font-size: 56px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.5rem;
}

.contact-detail,
.contact-detail-email {
  margin-top: 16px;
  font-size: 22px;
  font-weight: 400;
  color: #868e96;
  text-decoration: none;
  transition: color 0.3s, text-shadow 0.3s;
}

.contact-detail:hover,
.contact-detail-email:hover {
  color: #000000;
  text-shadow: 2px 1px 2px #b5b5b5;
}

.contact-subtitle {
  text-transform: uppercase;
  font-size: 16px;
  text-align: center;
  margin-bottom: 0.5rem;
}

.contact-text-div {
  margin-top: 1.5rem;
  text-align: center;
}

.contact-margin-top {
  margin-top: 3rem;
}

.contact-image-div > img {
  max-width: 100%;
  height: auto;
  margin-left: 1.5rem;
  margin-top: -4rem;
  border-radius: 50%;
  object-fit: cover;
  background: #f8fafc;
  box-shadow: 0 2px 12px rgba(34, 158, 217, 0.08);
}

.telegram-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 2rem;
  align-items: stretch;
  width: 100%;
  max-width: 370px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1.5px 4px rgba(34, 158, 217, 0.07);
  padding: 1.2rem 1.7rem 1.7rem 1.7rem;
  border: 2px solid #229ed9;
  margin-left: auto;
  margin-right: auto;
  transition: box-shadow 0.2s, border 0.2s;
}

.dark-mode .telegram-form {
  background: #181c24;
  border-color: #229ed9;
}

.telegram-form input,
.telegram-form textarea {
  width: 100%;
  max-width: 100%;
  padding: 0.7rem 1rem;
  border-radius: 6px;
  border: 1px solid #d0d7de;
  font-size: 2rem;
  font-family: inherit;
  box-sizing: border-box;
  line-height: 1.4;
  background: #f8fafc;
  color: #222;
  transition: border 0.2s, box-shadow 0.2s;
}

.telegram-form input:focus,
.telegram-form textarea:focus {
  border: 1.5px solid #229ed9;
  outline: none;
  box-shadow: 0 0 0 2px rgba(34, 158, 217, 0.08);
}

.telegram-form textarea {
  min-height: 2.7rem;
  resize: vertical;
  display: block;
  font-size: 1rem;
}

.telegram-form input::placeholder {
  text-align: left;
  color: #b0b8c1;
  font-size: 1.6rem;
}

.telegram-form textarea::placeholder {
  text-align: left;
  color: #b0b8c1;
  font-size: 1rem;
}

.telegram-form button {
  background: linear-gradient(90deg, #229ed9 60%, #176cae 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.7rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(34, 158, 217, 0.08);
  margin-top: 0.5rem;
}

.telegram-form button:hover {
  background: linear-gradient(90deg, #176cae 60%, #229ed9 100%);
  box-shadow: 0 4px 16px rgba(34, 158, 217, 0.15);
}

.telegram-form-status {
  margin-top: 0.5rem;
  font-size: 1rem;
  color: #229ed9;
  text-align: center;
}

/* Responsive */
@media (max-width: 900px) {
  .contact-div-main {
    flex-direction: column;
    gap: 0;
    align-items: center;
    justify-content: center;
  }
  .contact-title {
    font-size: 40px;
  }
  .contact-detail,
  .contact-detail-email {
    font-size: 18px;
  }
  .telegram-form {
    max-width: 98vw;
    width: auto;
    padding: 1rem;
    margin-left: auto;
    margin-right: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/contact/Contact.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,aAAA;EACA,SAAA;AAEF;;AACA;EACE,cDUc;ACRhB;;AACA;EACE,SAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAEF;;AACA;;EAEE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDfS;ECgBT,qBAAA;EACA,wCAAA;AAEF;;AACA;;EAEE,cDvBU;ECwBV,gCAAA;AAEF;;AACA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAEF;;AACA;EACE,kBAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gFAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AAEF;;AAAA;EACE,mBAAA;EACA,qBAAA;AAGF;;AADA;;EAEE,WAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;AAIF;;AAFA;;EAEE,2BAAA;EACA,aAAA;EACA,8CAAA;AAKF;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAMF;;AAJA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAOF;;AALA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAQF;;AANA;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,8CAAA;EACA,kBAAA;AASF;;AAPA;EACE,6DAAA;EACA,+CAAA;AAUF;;AARA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAWF;;AARA,eAAA;AACA;EACE;IACE,sBAAA;IACA,MAAA;IACA,mBAAA;IACA,uBAAA;EAWF;EATA;IACE,eAAA;EAWF;EATA;;IAEE,eAAA;EAWF;EATA;IACE,eAAA;IACA,WAAA;IACA,aAAA;IACA,iBAAA;IACA,kBAAA;EAWF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.contact-div-main {\n  display: flex;\n  gap: 2rem;\n}\n\n.dark-mode a {\n  color: $textColorDark;\n}\n\n.contact-div-main > * {\n  flex: 1;\n}\n\n.contact-title {\n  font-size: 56px;\n  font-weight: 500;\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.contact-detail,\n.contact-detail-email {\n  margin-top: 16px;\n  font-size: 22px;\n  font-weight: 400;\n  color: $subTitle;\n  text-decoration: none;\n  transition: color 0.3s, text-shadow 0.3s;\n}\n\n.contact-detail:hover,\n.contact-detail-email:hover {\n  color: $textColor;\n  text-shadow: 2px 1px 2px $contactDetailHoverTS;\n}\n\n.contact-subtitle {\n  text-transform: uppercase;\n  font-size: 16px;\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.contact-text-div {\n  margin-top: 1.5rem;\n  text-align: center;\n}\n\n.contact-margin-top {\n  margin-top: 3rem;\n}\n\n.contact-image-div > img {\n  max-width: 100%;\n  height: auto;\n  margin-left: 1.5rem;\n  margin-top: -4rem;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #f8fafc;\n  box-shadow: 0 2px 12px rgba(34, 158, 217, 0.08);\n}\n\n.telegram-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 2rem;\n  align-items: stretch;\n  width: 100%;\n  max-width: 370px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1.5px 4px rgba(34, 158, 217, 0.07);\n  padding: 1.2rem 1.7rem 1.7rem 1.7rem;\n  border: 2px solid #229ed9;\n  margin-left: auto;\n  margin-right: auto;\n  transition: box-shadow 0.2s, border 0.2s;\n}\n.dark-mode .telegram-form {\n  background: #181c24;\n  border-color: #229ed9;\n}\n.telegram-form input,\n.telegram-form textarea {\n  width: 100%;\n  max-width: 100%;\n  padding: 0.7rem 1rem;\n  border-radius: 6px;\n  border: 1px solid #d0d7de;\n  font-size: 2rem;\n  font-family: inherit;\n  box-sizing: border-box;\n  line-height: 1.4;\n  background: #f8fafc;\n  color: #222;\n  transition: border 0.2s, box-shadow 0.2s;\n}\n.telegram-form input:focus,\n.telegram-form textarea:focus {\n  border: 1.5px solid #229ed9;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(34, 158, 217, 0.08);\n}\n.telegram-form textarea {\n  min-height: 2.7rem;\n  resize: vertical;\n  display: block;\n  font-size: 1rem;\n}\n.telegram-form input::placeholder{\n  text-align: left;\n  color: #b0b8c1;\n  font-size: 1.6rem;\n}\n.telegram-form textarea::placeholder {\n  text-align: left;\n  color: #b0b8c1;\n  font-size: 1rem;\n}\n.telegram-form button {\n  background: linear-gradient(90deg, #229ed9 60%, #176cae 100%);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.7rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, box-shadow 0.2s;\n  box-shadow: 0 2px 8px rgba(34, 158, 217, 0.08);\n  margin-top: 0.5rem;\n}\n.telegram-form button:hover {\n  background: linear-gradient(90deg, #176cae 60%, #229ed9 100%);\n  box-shadow: 0 4px 16px rgba(34, 158, 217, 0.15);\n}\n.telegram-form-status {\n  margin-top: 0.5rem;\n  font-size: 1rem;\n  color: #229ed9;\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .contact-div-main {\n    flex-direction: column;\n    gap: 0;\n    align-items: center;\n    justify-content: center;\n  }\n  .contact-title {\n    font-size: 40px;\n  }\n  .contact-detail,\n  .contact-detail-email {\n    font-size: 18px;\n  }\n  .telegram-form {\n    max-width: 98vw;\n    width: auto;\n    padding: 1rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
